import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PAGES } from '../data';
import logo from '../logo_1.svg';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  const pagePath = (p) => (p === 'Home' ? '/' : `/${p.toLowerCase()}`);

  return (
    <>
      <style>{`
        .desktop-nav { display: flex; gap: 2.2rem; align-items: center; }
        .hamburger-btn { display: none; }
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .hamburger-btn { display: flex !important; }
        }
      `}</style>

      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
        background: scrolled ? 'var(--nav-bg)' : 'var(--nav-bg-soft)',
        backdropFilter: 'blur(18px)',
        borderBottom: scrolled ? `1px solid var(--border-2)` : '1px solid transparent',
        boxShadow: scrolled ? 'var(--sh)' : 'none',
        transition: 'all .35s',
        padding: '0 clamp(1rem,4vw,2.5rem)',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        height: '66px',
      }}>

        {/* Logo */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '10px', textDecoration: 'none', flexShrink: 0 }}>
          <div>
             <img src={logo} alt="ELBOT Logo"  style={{ width: '170px' }}  />
          </div>
        </Link>

        {/* Desktop Links */}
        <div className="desktop-nav">
          {PAGES.map(p => {
            const active = location.pathname === pagePath(p);
            return <Link key={p} to={pagePath(p)} className={`nav-link ${active ? 'active' : ''}`}>{p}</Link>;
          })}
          {/* <Link to="/contact" className="btn-primary" style={{ padding: '9px 22px', fontSize: '.85rem' }}>Get Quote</Link> */}
        </div>

        {/* Hamburger */}
        <button
          className="hamburger-btn"
          onClick={() => setMenuOpen(!menuOpen)}
          style={{
            flexDirection: 'column', justifyContent: 'center', alignItems: 'center', gap: '5px',
            width: '42px', height: '42px', background: 'transparent',
            border: '1.5px solid var(--accent-30)', borderRadius: '8px',
            cursor: 'pointer', padding: '8px',
          }}
        >
          <span style={{ width: '18px', height: '2px', background: 'var(--o)', display: 'block', transition: 'all .3s', transform: menuOpen ? 'rotate(45deg) translate(5px,5px)' : 'none' }} />
          <span style={{ width: '18px', height: '2px', background: 'var(--o)', display: 'block', transition: 'all .3s', opacity: menuOpen ? 0 : 1 }} />
          <span style={{ width: '18px', height: '2px', background: 'var(--o)', display: 'block', transition: 'all .3s', transform: menuOpen ? 'rotate(-45deg) translate(5px,-5px)' : 'none' }} />
        </button>
      </nav>

      {/* Mobile Dropdown */}
      {menuOpen && (
        <div style={{
          position: 'fixed', top: '66px', left: 0, right: 0, zIndex: 999,
          background: 'var(--nav-menu-bg)', backdropFilter: 'blur(18px)',
          borderBottom: `1px solid var(--border-2)`,
          boxShadow: 'var(--shM)',
          padding: '1rem clamp(1rem,4vw,2.5rem) 1.5rem',
          display: 'flex', flexDirection: 'column',
          animation: 'fadeUp .25s ease',
        }}>
          {PAGES.map(p => {
            const active = location.pathname === pagePath(p);
            return (
              <Link key={p} to={pagePath(p)} className={`nav-link ${active ? 'active' : ''}`}
                style={{ padding: '1rem 0', fontSize: '1rem', borderBottom: '1px solid var(--border-6)', display: 'block', letterSpacing: '2px' }}>
                {p}
              </Link>
            );
          })}
          {/* <Link to="/contact" className="btn-primary" style={{ marginTop: '1.2rem', justifyContent: 'center', fontSize: '1rem' }}>
            Get Quote →
          </Link> */}
        </div>
      )}
    </>
  );
}
